// extracted by mini-css-extract-plugin
export default {"products":"mw-z","card":"nw-z","oosMessaging":"ow-z"};